import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UploadComponent } from './upload/upload.component';

export const routes: Routes = [
  {
    path: '',
    component: UploadComponent,
    canActivate: [MsalGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
